import React, { Component } from 'react';

import '../../styles/modals/AnnouncementModal.css';

// An entry from Constants.ANNOUNCEMENTS that has no modal of its own: its title
// and paragraphs, and a way out.
class AnnouncementModal extends Component {
  // A paragraph is a string or a list of pieces; see Constants.ANNOUNCEMENTS.
  renderParagraph = (paragraph, i) => {
    const pieces = typeof paragraph === 'string' ? [paragraph] : paragraph;

    return (
      <div className="announcement-modal-paragraph" key={i}>
        { pieces.map((piece, j) => (
          typeof piece === 'string' ? piece : <strong key={j}>{piece.strong}</strong>
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className="announcement-modal">
        <div className="announcement-modal-title">
          {this.props.announcement.title}
        </div>
        { this.props.announcement.paragraphs.map(this.renderParagraph) }

        <button className="announcement-modal-close" onClick={this.props.onClose}>
          Close
        </button>
      </div>
    );
  }
}

export default AnnouncementModal;
